import React from "react";
import { CaretRight, CaretLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const CategoryTabs = ({ setSelectedCategory, selectedCategory, isInner }) => {
  const categories = [
    { name: "trainings-and-workshops", label: "Trainings & Workshops" },
    // { name: "training-materials", label: "Training Materials" },
    // { name: "certifications", label: "Certifications" },
  ];

  return (
    <div className="flex flex-wraps overflow-x-scroll lg:overflow-x-hidden mb-14 lg:flex-col gap-6 pb-4  ">
      {categories.map((category) => (
        <Link
          key={category.name}
          to={{
            pathname: isInner ? "/academy" : "",
            search: `?category=${category.name}`, // Add category as a query param
          }}
          state={{ selectedCategory: category.name }} // Pass selectedCategory via state
          onClick={() => !isInner && setSelectedCategory(category.name)}
          className={`flex items-center gap-x-2 text-2xl min-w-[fit-content] lg:text-3xl bebas transition ease-in duration-300 text-start group ${
            selectedCategory === category.name
              ? "text-white"
              : "text-font hover:text-white"
          }`}
        >
          {isInner && (
            <span
              className={`text-2xl transition ease-in duration-300 ${
                selectedCategory === category.name
                  ? "opacity-100"
                  : "opacity-0 group-hover:opacity-100"
              }`}
            >
              <CaretLeft />
            </span>
          )}
          {category.label}
          {!isInner && (
            <span
              className={`text-2xl transition ease-in duration-300 ${
                selectedCategory === category.name
                  ? "opacity-100"
                  : "opacity-0 group-hover:opacity-100"
              }`}
            >
              <CaretRight />
            </span>
          )}
        </Link>
      ))}
    </div>
  );
};

export default CategoryTabs;
